import styled from 'styled-components';

export const TableSearchPanel = styled.div`
  padding: 8px 12px;
`;
